import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 19h18l-9 -15l-9 15","key":"svg-0"}]]

const IconBrandVercel = createReactComponent('outline', 'brand-vercel', 'BrandVercel', __iconNode);

export default IconBrandVercel;